import React from "react"
import "./style.scss"
// import LearnMore from "../../elements/learnmore/LearnMore"
import Tag from "../../elements/werseltags/Tags"

const ServicesSection = ({ werselData, tags }) => {
  return (
    <div className="homepage_serviceSection">
      <div className="why_wersel_area" style={{ display:'flex' }}>
        <div className="col-sm-5	col-md-5	col-lg-5" style={{ display: 'contents' }}>
        <div className="text-area">
          {werselData.productDescription && (
            <p className="small_desc">{werselData.productDescription}</p>
          )}
          <h1 className="why_wersel">{werselData.mainTitle}</h1>
          <p className="seo_text">{werselData.subTitle}</p>
          {/* <LearnMore url="/our-story" withArrow /> */}
        </div>
        </div>
        <div className="col-sm-7	col-md-7	col-lg-7" style={{ padding: '1rem 0rem' }}>
        <Tag tags={tags} />
        </div>
      </div>
    </div>
  )
}

export default ServicesSection
